/* Overlay-Suche: Zustandswechsel, Fokusfalle und Abruf der Vorschlaege.
   Kein Framework, keine Abhaengigkeit zum Theme-JS. */
(() => {
  const wurzel = document.getElementById('paws-suche');
  if (!wurzel) return;

  const datenEl = document.getElementById('paws-suche-daten');
  if (!datenEl) return;

  let CFG;
  try {
    CFG = JSON.parse(datenEl.textContent);
  } catch (e) {
    return;
  }

  const panel = wurzel.querySelector('.paws-suche__panel');
  const eingabe = wurzel.querySelector('.paws-suche__input');
  const formular = wurzel.querySelector('.paws-suche__form');
  const trefferBox = wurzel.querySelector('.paws-suche__treffer');
  const status = wurzel.querySelector('.paws-suche__status');
  const leerenBtn = wurzel.querySelector('.paws-suche__leeren');
  if (!panel || !eingabe || !trefferBox) return;

  const MIN_ZEICHEN = CFG.minZeichen || 2;
  const speicher = new Map();
  let abbruch = null;
  let tippTakt = null;
  let vorherFokus = null;
  let scrollMerker = 0;
  let offen = false;

  /* ------------------------------------------------------------- Zustaende */

  const setzeZustand = (name) => {
    wurzel.setAttribute('data-zustand', name);
  };

  const meldeStatus = (text) => {
    if (status) status.textContent = text || '';
  };

  /* ---------------------------------------------------------- Oeffnen / Zu */

  const fokussierbare = () =>
    Array.from(
      panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => el.offsetParent !== null || el === eingabe);

  const oeffnen = (ausloeser) => {
    if (offen) return;
    offen = true;
    vorherFokus = ausloeser || document.activeElement;

    scrollMerker = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = `-${scrollMerker}px`;
    document.body.classList.add('paws-suche-offen');

    wurzel.hidden = false;
    // erst im naechsten Frame umschalten, sonst laeuft die Blende nicht
    requestAnimationFrame(() => wurzel.setAttribute('data-offen', 'true'));

    document.querySelectorAll('[data-paws-suche-oeffnen]').forEach((el) => {
      el.setAttribute('aria-expanded', 'true');
    });

    window.setTimeout(() => eingabe.focus({ preventScroll: true }), 60);
    // Die Spuren sind erst jetzt vermessbar, also Pfeile neu bewerten.
    window.setTimeout(() => pruefer.forEach((f) => f()), 120);
  };

  const schliessen = () => {
    if (!offen) return;
    offen = false;
    wurzel.setAttribute('data-offen', 'false');

    document.body.classList.remove('paws-suche-offen');
    document.body.style.top = '';
    window.scrollTo(0, scrollMerker);

    document.querySelectorAll('[data-paws-suche-oeffnen]').forEach((el) => {
      el.setAttribute('aria-expanded', 'false');
    });

    window.setTimeout(() => {
      if (!offen) wurzel.hidden = true;
    }, 200);

    if (vorherFokus && typeof vorherFokus.focus === 'function') {
      vorherFokus.focus({ preventScroll: true });
    }
  };

  /* ------------------------------------------------------------ Abruf */

  const anzeigen = (markup) => {
    trefferBox.innerHTML = markup;
    const traeger = trefferBox.querySelector('[data-paws-anzahl]');
    const anzahl = traeger ? parseInt(traeger.getAttribute('data-paws-anzahl'), 10) || 0 : 0;

    if (anzahl > 0) {
      setzeZustand('treffer');
      meldeStatus(`${anzahl} ${anzahl === 1 ? CFG.texte.einTreffer : CFG.texte.treffer}`);
    } else {
      setzeZustand('leer');
      meldeStatus(CFG.texte.keinTreffer);
    }

    // Preise/Waehrung nachziehen, falls die Waehrungsumschaltung aktiv ist
    document.dispatchEvent(new CustomEvent('currency:update'));
  };

  const holen = (begriff) => {
    const schluessel = begriff.toLowerCase();
    if (speicher.has(schluessel)) {
      anzeigen(speicher.get(schluessel));
      return;
    }

    if (abbruch) abbruch.abort();
    abbruch = new AbortController();

    setzeZustand('laedt');
    meldeStatus(CFG.texte.laedt);

    const url =
      `${CFG.vorschlagUrl}?q=${encodeURIComponent(begriff)}` +
      `&resources[type]=product,collection,page` +
      `&resources[limit]=10` +
      `&section_id=${CFG.trefferSection}`;

    fetch(url, { signal: abbruch.signal })
      .then((antwort) => {
        if (!antwort.ok) throw new Error(String(antwort.status));
        return antwort.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const teil = doc.querySelector(`#shopify-section-${CFG.trefferSection}`);
        const markup = teil ? teil.innerHTML : '';
        speicher.set(schluessel, markup);
        anzeigen(markup);
      })
      .catch((fehler) => {
        if (fehler.name === 'AbortError') return;
        // Bei Netzfehler nicht faelschlich "nichts gefunden" behaupten
        setzeZustand('start');
        meldeStatus('');
      });
  };

  const auswerten = () => {
    const begriff = eingabe.value.trim();
    wurzel.setAttribute('data-hat-text', begriff.length > 0 ? 'true' : 'false');

    if (begriff.length < MIN_ZEICHEN) {
      if (abbruch) abbruch.abort();
      setzeZustand('start');
      meldeStatus('');
      trefferBox.innerHTML = '';
      return;
    }
    holen(begriff);
  };

  /* ------------------------------------------------------------- Ereignisse */

  eingabe.addEventListener('input', () => {
    window.clearTimeout(tippTakt);
    tippTakt = window.setTimeout(auswerten, 280);
  });

  if (formular) {
    formular.addEventListener('submit', (ev) => {
      const begriff = eingabe.value.trim();
      if (!begriff) ev.preventDefault();
    });
  }

  if (leerenBtn) {
    leerenBtn.addEventListener('click', () => {
      eingabe.value = '';
      auswerten();
      eingabe.focus();
    });
  }

  wurzel.querySelectorAll('[data-paws-suche-schliessen]').forEach((el) => {
    el.addEventListener('click', schliessen);
  });

  // Klick neben das Panel schliesst (auf Mobil fuellt das Panel den Schirm)
  wurzel.addEventListener('mousedown', (ev) => {
    if (ev.target === wurzel) schliessen();
  });

  wurzel.querySelectorAll('[data-paws-begriff]').forEach((el) => {
    el.addEventListener('click', () => {
      eingabe.value = el.getAttribute('data-paws-begriff') || '';
      eingabe.focus();
      auswerten();
    });
  });

  document.addEventListener('keydown', (ev) => {
    if (!offen) return;

    if (ev.key === 'Escape') {
      ev.preventDefault();
      schliessen();
      return;
    }

    if (ev.key !== 'Tab') return;

    const liste = fokussierbare();
    if (!liste.length) return;
    const erster = liste[0];
    const letzter = liste[liste.length - 1];

    if (ev.shiftKey && document.activeElement === erster) {
      ev.preventDefault();
      letzter.focus();
    } else if (!ev.shiftKey && document.activeElement === letzter) {
      ev.preventDefault();
      erster.focus();
    }
  });

  /* --------------------------------------------------------- Ausloeser */

  const binden = (el) => {
    if (el.dataset.pawsSucheGebunden === 'ja') return;
    el.dataset.pawsSucheGebunden = 'ja';
    el.setAttribute('aria-expanded', 'false');
    el.setAttribute('aria-controls', 'paws-suche');
    el.addEventListener('click', (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      oeffnen(el);
    });
  };

  const ausloeserSuchen = () => {
    document.querySelectorAll('[data-paws-suche-oeffnen]').forEach(binden);

    // Vorhandene Such-Symbole des Themes uebernehmen, damit die Schublade
    // des Themes gar nicht erst aufgeht.
    if (CFG.themeAusloeserUebernehmen) {
      document
        .querySelectorAll('a[aria-controls="drawer-search-form"]')
        .forEach((el) => {
          el.setAttribute('data-paws-suche-oeffnen', '');
          binden(el);
        });
    }
  };

  ausloeserSuchen();

  // Kopfbereich und mobile Werkzeugleiste werden teils spaeter nachgeladen
  if (CFG.themeAusloeserUebernehmen) {
    const beobachter = new MutationObserver(() => ausloeserSuchen());
    beobachter.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => beobachter.disconnect(), 8000);
  }

  // Am Rechner gehoert die Leiste in den Kopfbereich, darunter unter ihn.
  // Nur die globale Leiste wandert mit, nicht die der Suchergebnisseite.
  const leiste = document.querySelector('.paws-suche-leiste[data-paws-kopfleiste]');
  if (leiste && !leiste.classList.contains('paws-suche-leiste--nur-mobil')) {
    const heimat = leiste.parentElement;
    const naechstes = leiste.nextElementSibling;
    const mq = window.matchMedia('(min-width: 1150px)');

    const platzieren = () => {
      const ziel = document.querySelector('.hdt-site-top_nav');
      if (mq.matches && ziel) {
        if (leiste.parentElement !== ziel) {
          ziel.prepend(leiste);
          leiste.setAttribute('data-im-kopf', 'true');
          document.body.classList.add('paws-suche-leiste-im-kopf');
        }
      } else if (leiste.parentElement !== heimat) {
        heimat.insertBefore(leiste, naechstes);
        leiste.removeAttribute('data-im-kopf');
        document.body.classList.remove('paws-suche-leiste-im-kopf');
      }
    };

    platzieren();
    mq.addEventListener('change', platzieren);
    // Der Kopfbereich kann nach dem Laden neu aufgebaut werden.
    window.setTimeout(platzieren, 1200);
  }

  // Waagerechte Spuren bekommen Pfeile statt eines sichtbaren Rollbalkens.
  const pruefer = [];
  const PFEIL_SVG =
    '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="9 18 15 12 9 6"></polyline></svg>';

  const spurRuesten = (spur) => {
    if (spur.dataset.pfeile === 'ja') return;
    spur.dataset.pfeile = 'ja';

    const huelle = document.createElement('div');
    huelle.className = 'paws-spur';
    spur.parentNode.insertBefore(huelle, spur);
    huelle.appendChild(spur);

    const machPfeil = (richtung, beschriftung) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = `paws-spur__pfeil paws-spur__pfeil--${richtung === 1 ? 'vor' : 'zurueck'}`;
      btn.setAttribute('aria-label', beschriftung);
      btn.innerHTML = PFEIL_SVG;
      if (richtung === -1) btn.firstElementChild.style.transform = 'rotate(180deg)';
      btn.addEventListener('click', () => {
        spur.scrollBy({ left: richtung * Math.round(spur.clientWidth * 0.8), behavior: 'smooth' });
      });
      huelle.appendChild(btn);
      return btn;
    };

    const zurueck = machPfeil(-1, 'Nach links');
    const vor = machPfeil(1, 'Nach rechts');

    const pruefen = () => {
      const rest = spur.scrollWidth - spur.clientWidth - spur.scrollLeft;
      zurueck.hidden = spur.scrollLeft <= 2;
      vor.hidden = rest <= 2;
    };

    spur.addEventListener('scroll', pruefen, { passive: true });
    window.addEventListener('resize', pruefen);
    if ('ResizeObserver' in window) new ResizeObserver(pruefen).observe(spur);
    pruefer.push(pruefen);
    pruefen();
  };

  const spurenSuchen = () => {
    wurzel.querySelectorAll('.paws-suche__slider, .paws-suche__pillen').forEach(spurRuesten);
  };

  spurenSuchen();

  setzeZustand('start');
})();
